export default __webpack_public_path__ + "static/media/thunderbird.6803f4dd.png";